(() => {
  class SmoothAccordion {
    constructor(element) {
      this.el = element;
      this.trigger = this.el.querySelector('.custom-accordion__trigger');
      this.content = this.el.querySelector('.custom-accordion__content');
      this.inner = this.el.querySelector('.custom-accordion__content-inner');
      this.isAnimating = false;

      if (!this.trigger || !this.content || !this.inner) return;

      this.onClick = this.onClick.bind(this);
      this.onResize = this.onResize.bind(this);

      this.trigger.addEventListener('click', this.onClick);
      window.addEventListener('resize', this.onResize);

      this.setupInitialState();
    }

    setupInitialState() {
      const shouldOpen = this.el.dataset.initialOpen === 'true';

      if (shouldOpen) {
        this.el.classList.add('is-open');
        this.trigger.setAttribute('aria-expanded', 'true');
        this.content.style.height = 'auto';
        this.content.style.opacity = '1';
        this.content.style.visibility = 'visible';
      } else {
        this.el.classList.remove('is-open');
        this.trigger.setAttribute('aria-expanded', 'false');
        this.content.style.height = '0px';
        this.content.style.opacity = '0';
        this.content.style.visibility = 'hidden';
      }
    }

    onClick() {
      if (this.isAnimating) return;

      if (this.el.classList.contains('is-open')) {
        this.close();
      } else {
        this.open();
      }
    }

    open() {
      this.isAnimating = true;

      this.el.classList.add('is-open');
      this.trigger.setAttribute('aria-expanded', 'true');

      this.content.style.visibility = 'visible';
      this.content.style.opacity = '1';

      const endHeight = this.inner.offsetHeight;

      this.content.style.height = '0px';

      requestAnimationFrame(() => {
        this.content.style.height = `${endHeight}px`;
      });

      const onEnd = (event) => {
        if (event.propertyName !== 'height') return;
        this.content.style.height = 'auto';
        this.isAnimating = false;
        this.content.removeEventListener('transitionend', onEnd);
      };

      this.content.addEventListener('transitionend', onEnd);
    }

    close() {
      this.isAnimating = true;

      const startHeight = this.inner.offsetHeight;
      this.content.style.height = `${startHeight}px`;

      requestAnimationFrame(() => {
        this.el.classList.remove('is-open');
        this.trigger.setAttribute('aria-expanded', 'false');
        this.content.style.height = '0px';
        this.content.style.opacity = '0';
      });

      const onEnd = (event) => {
        if (event.propertyName !== 'height') return;
        this.content.style.visibility = 'hidden';
        this.isAnimating = false;
        this.content.removeEventListener('transitionend', onEnd);
      };

      this.content.addEventListener('transitionend', onEnd);
    }

    onResize() {
      if (this.el.classList.contains('is-open') && !this.isAnimating) {
        this.content.style.height = 'auto';
      }
    }

    destroy() {
      this.trigger?.removeEventListener('click', this.onClick);
      window.removeEventListener('resize', this.onResize);
    }
  }

  const instances = new WeakMap();

  function initSmoothAccordions(scope = document) {
    const accordions = scope.querySelectorAll('[data-accordion]');

    accordions.forEach((accordion) => {
      if (instances.has(accordion)) return;
      instances.set(accordion, new SmoothAccordion(accordion));
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    initSmoothAccordions();
  });

  document.addEventListener('shopify:section:load', (event) => {
    initSmoothAccordions(event.target);
  });

  document.addEventListener('shopify:section:reorder', (event) => {
    initSmoothAccordions(event.target);
  });

  document.addEventListener('shopify:block:select', (event) => {
    const accordion = event.target.closest('[data-accordion]');
    if (!accordion) return;

    const trigger = accordion.querySelector('.custom-accordion__trigger');
    if (!accordion.classList.contains('is-open') && trigger) {
      trigger.click();
    }
  });
})();